import { useEffect, useState, useRef } from "react";
import classes from "./TcAndPrivacySidebar.module.scss";

type Props = {
  items: {
    id: string;
    header: string;
  }[];
};

function TcAndPrivacySidebar({ items }: Props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const isScrollingRef = useRef(false);

  const handleScroll = (entries: IntersectionObserverEntry[]) => {
    if (isScrollingRef.current) return;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const index = items.findIndex((el: any) => el.id === entry.target.id);
        if (index !== -1) {
          setActiveIndex(index);
        }
      }
    });
  };

  useEffect(() => {
    observerRef.current = new IntersectionObserver(handleScroll, {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    });

    items.forEach((el) => {
      const section = document.getElementById(el.id);
      if (section) {
        observerRef.current!.observe(section);
      }
    });

    return () => {
      observerRef.current?.disconnect();
    };
  }, [items]);

  const scrollToElement = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 130,
        behavior: "smooth",
      });

      setTimeout(() => {
        isScrollingRef.current = false;
      }, 500);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>Contents</div>

      {items.map((item, index) => (
        <a
          href={`#${item.id}`}
          className={
            index === activeIndex
              ? `${classes["item"]} ${classes["active"]}`
              : classes["item"]
          }
          key={index}
          onClick={(e) => {
            e.preventDefault();
            setActiveIndex(index);
            isScrollingRef.current = true;
            scrollToElement(item.id);
          }}
        >
          {item.header}
        </a>
      ))}
    </div>
  );
}

export default TcAndPrivacySidebar;
